import classNames from 'classnames'
import {memo} from 'react'
import {useLocation} from 'react-router-dom'

import Measure from '../../../../../../../containers/Measure'
import {getHrefWithQueryParams} from '../../../../../../../routes'
import {base_uri} from '../../../../../../../types/BS_types'
import IframeAdapter from '../../../../../../common/IframeAdapter/IframeAdapter'
import Redirect from '../../../../../../common/Redirect/Redirect'

import {useGameTab, useJobGameTabContext} from './GameTab.hooks'

import styles from './GameTab.css'

const MIN_HEIGHT_FOR_FULL_SIZE_GAME = 700

function GameTab() {
  const location = useLocation()
  const jobGameTabContext = useJobGameTabContext()
  const {iframe, focusIframe} = useGameTab()

  if (!jobGameTabContext.wasFound) {
    return (
      <Redirect
        to={getHrefWithQueryParams(location, null, params => ({
          ...params,
          tab: null,
        }))}
        replace
      />
    )
  }

  return (
    <Measure client>
      {({measureRef, contentRect}) => (
        <div ref={measureRef} className={styles.tab}>
          {contentRect?.client?.height != null && (
            <IframeAdapter
              iframeRef={iframe}
              className={classNames(styles.game, {
                [styles.narrow]: contentRect.client.height < MIN_HEIGHT_FOR_FULL_SIZE_GAME,
              })}
              title="2048"
              src={`${base_uri}/js/ring/2048/index.htm`}
              onIframeLoaded={focusIframe}
            />
          )}
        </div>
      )}
    </Measure>
  )
}

export default memo(GameTab)
